// Vocabulary: readers see this feature as "owner reviews"; code, routes, DealHunt paths and
// analytics events keep the historical "owner note" name on purpose — do not rename them.

import styles from './OwnerExample.module.css'
import OwnerNoteCard from '../OwnerNoteCard'
import { Aggregate } from '../OwnerFigures'
import { OWNER_DEFAULT_QUESTIONS } from 'lib/dealhunt/types'
import { EXAMPLE_AGGREGATE, EXAMPLE_NOTE } from 'lib/owner-notes/example'

/**
 * Proposal 4 (2026-09-05 review): what the product page shows once owners write in —
 * the aggregate block the reader's answers feed, then one note card. Constants only,
 * labelled as examples; the reader's own pseudonym does not exist before the mint.
 */
const OwnerExample: React.VFC = () => (
  <div className={styles.example} aria-label="Example of owner reviews on a product page">
    <p className={styles.exampleLabel}>
      {'Example · what the product page shows once owners write in'}
    </p>
    <Aggregate aggregate={EXAMPLE_AGGREGATE} gateMet={false} />
    <p className={styles.exampleIntro}>
      {
        'Your four reads and your buy-again answer land there. And your owner review, under your pseudonym, in the list beneath it:'
      }
    </p>
    <p className={styles.exampleLabel}>{'Example · not a real owner of this product'}</p>
    <OwnerNoteCard note={EXAMPLE_NOTE} questions={OWNER_DEFAULT_QUESTIONS} />
  </div>
)

export default OwnerExample
